import {
  GET_REVENUE_CENTERS_REQUESTED,
  GET_REVENUE_CENTERS_SUCCEEDED,
  GET_REVENUE_CENTERS_FAILED,
} from './constants'
import api from '../../utils/api'

export const getRevenueCentersRequested = () => ({
  type: GET_REVENUE_CENTERS_REQUESTED
})

export const getRevenueCentersSucceeded = (payload) => ({
  type: GET_REVENUE_CENTERS_SUCCEEDED,
  payload
})

export const getRevenueCentersFailed = () => ({
  type: GET_REVENUE_CENTERS_FAILED
})

export const loadRevenueCenters = (venueUuid) => dispatch => {
  dispatch(getRevenueCentersRequested())

  return api
    .fetchRevenueCenters(venueUuid)
    .then(response => dispatch(getRevenueCentersSucceeded(response.data.stands)))
    .catch(() => dispatch(getRevenueCentersFailed()))
}
